import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as domain from '@common/domain/entities/PartyContact';
import * as models from '@common/domain/models/PartyContactDTO';
import * as app from '@framework/app';
import { IApiServiceCommand } from '@services/api/api.service';
import { PartyContactTypeEndPoints } from '@common/domain/entities/PartyContactType';
import { ViewType } from '../../../framework/core/Enums';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';


export class PartyContactFormFields extends domain.PartyContactFormFields {
  //public typeid: IFieldOptions = { field: "typeId", dataEndPoint: new PartyContactTypeEndPoints().get, dataIdField: "id", dataDisplayField: "name" };
  //public value: IFieldOptions = { field: "value" };
  //public isdefault: IFieldOptions = { field: "isDefault"};
  constructor() {
    super();
    this.splice(0);
    this.push(this.typeId);
    this.push(this.value);
    this.push(this.isDefault);
    this.typeId.name = "Type";
    this.typeId.viewType = ViewType.Dropdown;
    this.typeId.dataEndPoint = { url: app.config.controllerRouteRoot + "/partyContactType" };
    this.typeId.dataDisplayField = "name";
    this.typeId.dataIdField = "id";
  }
}

export class PartyContactEndPoints extends domain.PartyContactEndPoints implements IEntityEndPoints {
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/" + serviceCommand.context.entityId
    }
  };
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/ForUser/"
    }
  };
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/CreateForUser/"
    },
    method: 'post'
  };
  delete?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/delete/" + serviceCommand.context.entityId
    },
    method: 'post'
  };
  update?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/update/" + serviceCommand.context.entityId
    },
    method: 'post'
  };
  search?: IDataEndPoint = null;

}

export class SupplierPartyContactEndPoints extends domain.PartyContactEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/Supplier/partyContact/" + serviceCommand.context.entityId
    }
  };
  search?: IDataEndPoint = null;

}



export class PartyContactForm implements IFormOptions {
  protected PartyContactFormName: string = "organisationForm";
  protected PartyContactFormModel: models.PartyContactDTO = new models.PartyContactDTO();
  protected PartyContactFormEndPoints: PartyContactEndPoints = new PartyContactEndPoints();
  protected PartyContactFormFields: PartyContactFormFields = new PartyContactFormFields();
  public get name(): string { return this.PartyContactFormName };
  public get model(): models.PartyContactDTO { return this.PartyContactFormModel };
  public get endPoints(): IEntityEndPoints { return this.PartyContactFormEndPoints };
  public set endPoints(organisationEndPoints: IEntityEndPoints) {
    this.PartyContactFormEndPoints = organisationEndPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
  public get fields(): PartyContactFormFields { return this.PartyContactFormFields };
  public onLoaded: Function = function (context: any, entity?: any) {
    if (context.entityId == "00000000-0000-0000-0000-000000000000") {
      context.entityData.partyId = context.parent.previousEntityId;
    }
  }
}

export class PartyContactListColumns extends domain.PartyContactListColumns {
  constructor() {
    super();
    this.id.visible = false;
    if (this["id"]) this["id"].visible = false;
    if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
    if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    if (this["typeId"]) this.splice(this.indexOf(this["typeId"]), 1)
    if (this["partyId"]) this.splice(this.indexOf(this["partyId"]), 1)
    if (this["changedBy"]) this.splice(this.indexOf(this["changedBy"]), 1)
    if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
    this.unshift(FormBuilderControlListHelper.getListColumn("partyContactType.name", "Type", null, null, "partyContactType_name"));
  }
}

export class PartyContactList implements IGridOptions {
  protected PartyContactListColumns: PartyContactListColumns = new PartyContactListColumns();
  protected PartyContactListName: string = "PartyContactList";
  protected PartyContactListModel: models.PartyContactDTO = new models.PartyContactDTO();
  protected PartyContactListEndPoints: PartyContactEndPoints = new PartyContactEndPoints();
  public get name(): string { return this.PartyContactListName };
  public get model(): models.PartyContactDTO { return this.PartyContactListModel };
  public get endPoints(): IEntityEndPoints { return this.PartyContactListEndPoints };
  public set endPoints(PartyContactEndPoints: IEntityEndPoints) {
    this.PartyContactListEndPoints = PartyContactEndPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): PartyContactListColumns { return this.PartyContactListColumns };
}


export class PartyContactSpecificPartyEndPoints extends domain.PartyContactEndPoints implements IEntityEndPoints {
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/" + serviceCommand.context.entityId
    }
  };
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/ForUser/" + serviceCommand.context.entityId
    }
  };
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/CreateForUser/" + serviceCommand.context.parent.previousEntityId
    },
    method: 'post'
  };
  delete?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/delete/" + serviceCommand.context.entityId
    },
    method: 'post'
  };
  update?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/PartyContact/update/" + serviceCommand.context.entityId
    },
    method: 'post'
  };

  search?: IDataEndPoint = null;

}

export class PartyContactSpecificPartyList extends PartyContactList {
  protected PartyContactListEndPoints: PartyContactSpecificPartyEndPoints = new PartyContactSpecificPartyEndPoints();
}

export class PartyContactSpecificPartyForm extends PartyContactForm {
  protected PartyContactFormEndPoints: PartyContactSpecificPartyEndPoints = new PartyContactSpecificPartyEndPoints();
}

export class SupplierPartyContactList extends PartyContactList {
  protected PartyContactListEndPoints: SupplierPartyContactEndPoints = new SupplierPartyContactEndPoints();
}

export class SupplierPartyContactForm extends PartyContactForm {
  protected PartyContactFormEndPoints: SupplierPartyContactEndPoints = new SupplierPartyContactEndPoints();
  public canDelete?: boolean = true;
}

